import { ReactNode } from 'react';
import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import { content, description, overlay, title } from './modal.css';

interface ContentProps extends AlertDialogPrimitive.AlertDialogContentProps {
  children: ReactNode;
}

function Content({ children, ...props }: ContentProps) {
  return (
    <AlertDialogPrimitive.Portal>
      <AlertDialogPrimitive.Overlay className={overlay} />
      <AlertDialogPrimitive.Content className={content} {...props}>
        {children}
      </AlertDialogPrimitive.Content>
    </AlertDialogPrimitive.Portal>
  );
}

function Title({ children, ...props }: AlertDialogPrimitive.AlertDialogTitleProps) {
  return (
    <AlertDialogPrimitive.Title className={title} {...props}>
      {children}
    </AlertDialogPrimitive.Title>
  );
}

function Description({ children, ...props }: AlertDialogPrimitive.AlertDialogDescriptionProps) {
  return (
    <AlertDialogPrimitive.Description className={description} {...props}>
      {children}
    </AlertDialogPrimitive.Description>
  );
}

export const ModalDialog = AlertDialogPrimitive.Root;
export const ModalDialogTrigger = AlertDialogPrimitive.Trigger;
export const ModalDialogContent = Content;
export const ModalDialogTitle = Title;
export const ModalDialogDescription = Description;
export const ModalDialogAction = AlertDialogPrimitive.Action;
export const ModalDialogCancel = AlertDialogPrimitive.Cancel;
